(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-swatches"] && !Shopify.designMode) return;
  try {
    /* DEV-424: show the color name above a card swatch on mouse hover, on
     keyboard focus, and for a moment after a tap (touch screens have no
     hover). The bubble stays within the card's width. */
  (() => {
    const LABEL = 'swatches-variant-picker-component .variant-option__button-label--has-swatch';
    const labelFor = (event) => (event.target instanceof Element ? event.target.closest(LABEL) : null);
    let tip;
    let timer;

    const hide = () => {
      clearTimeout(timer);
      tip?.classList.remove('is-visible');
    };

    const show = (label) => {
      const name = label.querySelector('input')?.value;
      if (!name) return;
      if (!tip) {
        tip = document.createElement('div');
        tip.className = 'pr-swatch-tip';
        tip.setAttribute('aria-hidden', 'true');
        document.body.append(tip);
      }
      tip.textContent = name;
      const swatch = label.getBoundingClientRect();
      const row = (label.closest('swatches-variant-picker-component') || label).getBoundingClientRect();
      const box = tip.getBoundingClientRect();
      const left = Math.max(row.left, Math.min(swatch.left + swatch.width / 2 - box.width / 2, row.right - box.width));
      tip.style.left = `${Math.round(left + window.scrollX)}px`;
      tip.style.top = `${Math.round(swatch.top + window.scrollY - box.height - 8)}px`;
      tip.classList.add('is-visible');
    };

    document.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse') return;
      const label = labelFor(event);
      if (label) show(label);
    });

    document.addEventListener('pointerout', (event) => {
      if (event.pointerType !== 'mouse') return;
      const label = labelFor(event);
      if (label && !label.contains(/** @type {Node} */ (event.relatedTarget))) hide();
    });

    document.addEventListener('focusin', (event) => {
      const label = labelFor(event);
      if (label && label.matches(':has(:focus-visible)')) show(label);
    });

    document.addEventListener('focusout', (event) => {
      if (labelFor(event) && !document.querySelector(`${LABEL}:hover`)) hide();
    });

    document.addEventListener('pointerup', (event) => {
      if (event.pointerType === 'mouse') return;
      const label = labelFor(event);
      if (!label) return;
      show(label);
      clearTimeout(timer);
      timer = setTimeout(hide, 1600);
    });

    window.addEventListener('resize', hide);
  })();
  } catch(e) { console.error(e); }
})();

})();
